import React from 'react'
import { Layout, Menu } from 'antd';
import '../../style.css'
import { Logo, LoginMin } from '../../../assets/images';
import { CustomImage } from '../..';
const { Sider } = Layout;

const Sidebar = ({ isSidebarCollapsed, navigateTo, path, menu }) => {
    return (
        <Sider
            width={260}
            trigger={null}
            collapsible
            collapsed={isSidebarCollapsed}
            breakpoint="lg"
            className="container"
        >
            <div className="logo">
                <CustomImage
                    src={isSidebarCollapsed ? LoginMin : Logo}
                />
            </div>
            <Menu mode="inline" selectedKeys={[path]} onClick={({ item, key, keyPath, domEvent }) => navigateTo(key)}>
                {menu.map((item, index) =>
                    <Menu.Item key={item.path} icon={item.icon}>
                        {item.label}
                    </Menu.Item>
                )}
            </Menu>
        </Sider>
    )
}

export default Sidebar